// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2dE3A","footer":"ModalUpdate_footer__24hpZ"};